/**
 * Tantä custom menu:
 * - L1 → L2 slide panel with ‹ Parent back
 * - L3 = + / - accordion inside L2 (no extra side panel)
 * - Prevent panel overlap conflicts
 */
(function ($) {
  if (!$ || !document.getElementById('main-menu')) return;

  var animating = false;

  function resetMenuPanels() {
    var $root = $('#main-menu-panel');
    $('.main-menu-panel--child')
      .addClass('main-menu-panel--inactive-right')
      .removeClass('main-menu-panel--inactive-left is-active-panel')
      .attr('aria-hidden', 'true');
    $root
      .removeClass('main-menu-panel--inactive-left main-menu-panel--inactive-right')
      .addClass('is-active-panel')
      .attr('aria-hidden', 'false');
    $('.main-menu-toggle').removeClass('main-menu-toggle--back');
    $('.has-accordion').removeClass('is-open');
    $('.main-menu-accordion-toggle').attr('aria-expanded', 'false');
    $('.main-menu-accordion').attr('hidden', true);
    animating = false;
  }

  function closeMenu() {
    if (!$('html').hasClass('open-menu')) return;
    $('html').removeClass('open-menu');
    if (typeof theme !== 'undefined' && typeof theme.toggleNav === 'function') {
      theme.toggleNav();
    }
    resetMenuPanels();
  }

  function setActivePanel($panel) {
    $('.main-menu-panel').removeClass('is-active-panel');
    $panel.addClass('is-active-panel');
  }

  // L1 → L2 slide only (ignore accordion buttons)
  $(document).on('click', '.has-children > .main-menu-link', function (e) {
    if ($(this).hasClass('main-menu-accordion-toggle')) return;

    if (animating) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
    animating = true;

    var targetId = $(this).attr('aria-controls');
    var $target = targetId ? $('#' + targetId) : $();

    setTimeout(function () {
      $('.main-menu-toggle').removeClass('main-menu-toggle--back');
      if ($target.length) setActivePanel($target);
      // Reset accordions when entering a new L2 panel
      $target.find('.has-accordion').removeClass('is-open');
      $target.find('.main-menu-accordion-toggle').attr('aria-expanded', 'false');
      $target.find('.main-menu-accordion').attr('hidden', true);
      animating = false;
    }, 320);
  });

  $(document).on('click', '.main-menu-breadcrumbs__link', function () {
    if (animating) return;
    animating = true;
    var href = $(this).attr('href');
    var $target = href ? $(href) : $();
    setTimeout(function () {
      if ($target.length) setActivePanel($target);
      animating = false;
    }, 320);
  });

  // Third level: + / - accordion (only one open at a time)
  $(document).on('click', '.main-menu-accordion-toggle', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $btn = $(this);
    var $item = $btn.closest('.has-accordion');
    var $panel = $item.find('> .main-menu-accordion');
    var isOpen = $btn.attr('aria-expanded') === 'true';

    $btn.closest('.main-menu-links').find('.has-accordion').each(function () {
      var $other = $(this);
      if ($other[0] === $item[0]) return;
      $other.removeClass('is-open');
      $other.find('> .main-menu-accordion-toggle').attr('aria-expanded', 'false');
      $other.find('> .main-menu-accordion').attr('hidden', true);
    });

    if (isOpen) {
      $item.removeClass('is-open');
      $btn.attr('aria-expanded', 'false');
      $panel.attr('hidden', true);
    } else {
      $item.addClass('is-open');
      $btn.attr('aria-expanded', 'true');
      $panel.removeAttr('hidden');
    }
  });

  $(document).on('click', '.main-menu-close', function (e) {
    e.preventDefault();
    e.stopPropagation();
    closeMenu();
  });

  $(document).on('click', '.main-menu-toggle', function () {
    setTimeout(function () {
      if (!$('html').hasClass('open-menu')) {
        resetMenuPanels();
      } else {
        setActivePanel($('#main-menu-panel'));
      }
    }, 0);
  });

  $(document).on('click', '.bg-overlay', function () {
    setTimeout(function () {
      if (!$('html').hasClass('open-menu')) {
        resetMenuPanels();
      }
    }, 0);
  });

  setActivePanel($('#main-menu-panel'));
})(window.jQuery);
